/*
 * Application Insights JavaScript SDK - Web Analytics, 2.7.6
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export { ApplicationInsights } from "./JavaScriptSDK/ApplicationInsights";
//# sourceMappingURL=applicationinsights-analytics-js.js.map